export default function PhilosophySection() {
  return (
    <section className="py-24 md:py-28 relative overflow-hidden" style={{ backgroundColor: '#FDFAF5' }}>
      {/* Decorative ripple - left */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 pointer-events-none opacity-15">
        <div className="relative w-64 h-64 -translate-x-1/2">
          <div className="absolute inset-0 rounded-full border-2 border-forest-700" />
          <div className="absolute inset-6 rounded-full border border-forest-700" />
          <div className="absolute inset-12 rounded-full border border-forest-700" />
          <div className="absolute inset-20 rounded-full border border-forest-700" />
        </div>
      </div>
      {/* Decorative ripple - right */}
      <div className="absolute right-0 bottom-0 pointer-events-none opacity-10">
        <div className="relative w-48 h-48 translate-x-1/3 translate-y-1/3">
          <div className="absolute inset-0 rounded-full border-2 border-forest-700" />
          <div className="absolute inset-5 rounded-full border border-forest-700" />
          <div className="absolute inset-10 rounded-full border border-forest-700" />
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
        <div className="inline-block mb-8">
          <span className="text-forest-700 font-serif text-sm tracking-widest2">〔 設立の想い 〕</span>
        </div>

        <blockquote className="text-forest-800 font-serif font-light text-xl md:text-2xl leading-loose tracking-wider mb-10">
          「わが国の医療をとりまく現状を鑑み、東洋医学の持つ普遍的な価値を次世代へと繋ぎ、
          社会全体の健康と福祉に貢献することを我々は使命と考えます。」
        </blockquote>

        <div className="w-16 h-px bg-forest-600/40 mx-auto mb-6" />

        <p className="text-forest-600/70 text-sm font-serif tracking-wider">
          一般社団法人東洋医学未来推進協会<br />
          <span className="text-xs tracking-widest text-forest-500/60">設立趣旨より</span>
        </p>

        <div className="mt-12">
          <img
            src="/images/logo.jpeg"
            alt="OMFES"
            className="mx-auto w-72 md:w-96 h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
}
